import { Category } from "./category.interface";
import { FileType } from "./file.interface";
import { PagingModelV2 } from "./pagination.interface";
import { Tag } from "./tag.interface";

// export interface ProductModel extends PaginateModel {
//     data: Product[];
// }

export interface ProductModel {
    products: Product[];
    total: number;
}

/** Ton kho kha dung theo SKU tai 1 khu vuc — response cua product/productmeta/get-stock-by-skus. */
export interface ProductStockDto {
    sku: string;
    available: number;
}

export class Product {
    id: string;
    productID: number;
    name: string;
    slug: string;
    short_description: string;
    description: string;
    ingredients: string;
    type: string;
    imageUrls: string[];
    unit: string;
    volume: string;
    weight: number;
    currentPrice: number;
    basePrice: number;
    pricingTablePrice: number;
    dosageForm: DosageForm;
    sku: string;
    skU2: string;
    stockStatus: StockStatus;
    manufacturer: Manufacturer;
    quantityAvailable: number;
    status: boolean;
    metaTitle: string;
    metaDescription: string;
    metaImages: string[] = [];
    tags: Tag[];
    labels: Tag[];
    categories: Category[];
    productVariantIds: number[];
    additionalInfo: AdditionalInfo[] = [];
    productInfo: ProductInfo[] = [];
    isDisplay: boolean;
    toggleActionIcon: string;
    productSuggestions: any[] = [];
    productAlternatives : any[] = [];
    productOrderLimit: ProductOrderLimit;
    productOrderLimitByRegion: ProductOrderLimitByRegion[];
    stockStatusByRegions: stockStatusByRegion[];
    commonInfo?: string;
    instruction?: string;
    usage?: string;
    abnormalLimit: number;
    abnormalLimitByRegion: ProductAbnormalLimitByRegion[];
    wholesalePrices: WholesalePriceInfo[] | undefined;
}

export class ProductMeta {
    sku: string;
    productSuggestions: any[] = [];
    productAlternatives: any[] = [];
    productOrderLimitByRegion: ProductOrderLimitByRegion[];
    abnormalLimitByRegion: ProductAbnormalLimitByRegion[];
    stockStatusByRegions: stockStatusByRegion[];
    commonInfo: string;
    instruction: string;
    usage: string;
}

export class ProductInfo {
    name: string;
    value: string;
    type: ProductInfoType;
    path?: string;
    display: boolean = true;
}

export class AdditionalInfo {
    name: string;
    value: string;
    display: boolean = true;
}

export interface Manufacturer {
    code: string;
    name: string;
}

export enum DosageForm {
    Other = 0,
    Solution = 1,
    Tablet = 2,
    EffervescentTablet = 3,
    Powder = 4,
    Capsule = 5,
    Injection = 6,
}

export enum StockStatus {
    OutOfStock = 0,
    OnHand = 1, //the quantity of goods available for sale
    HandOuted = 2, //quantity of goods for which there is demand but no ready availability
    NotAvailable = 3, //products that are unavailable at present
    MadeToOrder = 4, //quantity of products available within a week based on orders received
    ReadyToShip = 5, //product quantity available for shipping
    Discontinued = 6, //the products that won’t be manufactured once the current stock finishes
    TempporarilyUnavailable = 7, //products unavailable as of now, but for which backorders will be taken when they become available
    NotAllowedToViewPrice = 8, //products that are not allowed to view price
    NotAllowedToOrder = 9, //products that are not allowed to order
    NotInBusinessScope = 10, //not in biz scope, show message do not allow to order
}

export enum ProductInfoType {
    Categories = 0,
    Dosage = 1,
    Unit = 2,
    Branch = 3,
    Manufacturer = 4,
    RegistrationNo = 5
}

export class RetriveUserModel {
    searchTerm?: string = "";
    offset?: number = 0;
    limit?: number = 10;
    sortBy?: string = "";
    category?: string = "";
}
export class ProductPagingModel extends PagingModelV2 {
    productSkus?: string[];
}
export class PaginationModel extends RetriveUserModel {
    totalItems: number = 10;
}
export class ProductExtend extends Product {
    isSelected: boolean = false;
    limitPerOrder: number = 0;
    limitTotal: number = 0;
    point: number = 0;
    isNewlyAdded?: boolean = false;
}

export class ProductOrderLimit {
    maxOrderQuantityPerOrder: number;
    maxOrderQuantityPerDay: number;
}

export class ProductOrderLimitByRegion {
    region: string;
    productOrderLimit: ProductOrderLimit;
}

export class ProductAbnormalLimitByRegion {
    region: string;
    abnormalLimit: number;
}

export class ProductQuantityByRegion {
    id?: string;
    region?: string;
    sku?: string;
    quantityChange?: number;
    timestamp?: Date;
    actor?: string;
    note?: string;
    orderId?: string;
    currentQuantity?: number;
    stock_status?: StockStatus | undefined;
}

export class ProductQuantityByRegionRequestModel {
    sku: string;
    quantityToSet: number;
    note?: string;
    region?: string;
}

export class stockStatusByRegion {
    region: string;
    stockStatus: StockStatus;
    quantity?: number;
}
export class WholesalePriceInfo {
    minQuantity: number;
    wholesalePrice: number;
    isValidWhosalePrice: boolean;
}
